.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--backdrop-background-color-primary, palette('backdrop-background', 'primary'));
  display: none;
  z-index: 9999;

  &.open {
    display: block;
  }
}

dialog {
  border: none;
}

.modal-content {
  display: flex;
  background-color: var(--background-color-primary, background-color('primary'));
  position: fixed;
  inset: 0;
  flex-direction: column;
  justify-content: space-between;

  @media (--md-min) {
    background-color: var(--background-color-secondary, background-color('secondary'));
    border: 1px solid var(--border-color-primary, border-color('primary'));
    width: 80%;
    margin: 0 auto;
    max-width: pxToRem(720);
    min-height: pxToRem(200);
    max-height: 70vh;
    top: 5vh;
    bottom: auto;
    border-radius: var(--radius-m, $radius-m);
    padding: 0;
  }
}

.modal-close {
  &:not(:focus-visible) {
    @include screen-reader-only();
  }
}

.modal-title {
  @include screen-reader-only();
}
